// src/components/Download.jsx
import React from 'react';
import { useTranslation } from '../context/AppContext';

export default function Download() {
  const { t } = useTranslation();

  return (
    <section id="download" className="py-16 px-6 bg-gray-100 dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-10">{t.download}</h2>
        <div className="flex flex-col md:flex-row justify-center gap-8">
          <div className="flex-1 flex flex-col items-center">
            <a
              href="/download/sonifly-windows-setup.exe"
              className="w-full bg-blue-600 text-white py-4 px-8 rounded-xl font-semibold shadow hover:bg-blue-700 transition transform hover:scale-105 dark:bg-blue-700 dark:hover:bg-blue-600"
            >
              🖥️ {t.winBtn}
            </a>
            <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">Windows 10/11</p>
          </div>
          <div className="flex-1 flex flex-col items-center">
            <a
              href="https://play.google.com/store/apps/details?id=com.mishanstvo.soniflyclient"
              className="w-full bg-green-600 text-white py-4 px-8 rounded-xl font-semibold shadow hover:bg-green-700 transition transform hover:scale-105 dark:bg-green-700 dark:hover:bg-green-600"
            >
              📱 {t.androidBtn}
            </a>
            <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">Android 7.0+</p>
          </div>
        </div>
      </div>
    </section>
  );
}